import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../services/auth/services/auth.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  
  // 🔥 User state
  user: { name: string, picture: string, roleName: string } = {
    name: 'Admin',
    picture: '', // Isay khali chora hai taake Nebular initials (alphabets) generate kare
    roleName: ''
  };

  themes = [
    { value: 'default', name: 'Light' },
    { value: 'dark', name: 'Dark' },
    { value: 'cosmic', name: 'Cosmic' },
    { value: 'corporate', name: 'Corporate' },
  ];

  currentTheme = 'default';
  userMenu = [ { title: 'Setting' }, { title: 'Log out' } ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    // 🔥 LOCAL STORAGE SE USER KA DATA NIKALNA
    this.loadUserFromLocalStorage();

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    // Logout logic
    this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe(({item: {title}}) => {
        if (title === 'Log out') {
          this.authService.logout().subscribe({
            next: () => {
              // Navigation handled in clearSession()
            },
            error: (err) => {
              console.error('Logout error:', err);
            }
          });
        }
      });

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  // 🔥 SMART USER DATA EXTRACTOR
  loadUserFromLocalStorage() {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const userData = JSON.parse(userStr);
        
        // 1. Naam nikalna (fullName ya name jo bhi mil jaye)
        this.user.name = userData.fullName || userData.name || userData.username || 'Admin';
        
        // 2. Role nikalna
        let roleName = userData?.role?.name || userData?.roleName || userData?.role || '';
        if (typeof roleName === 'object') {
           roleName = roleName?.name || '';
        }
        this.user.roleName = roleName;

        // 3. Picture ko jaan boojh kar khali kar diya taake Nebular khud Alphabets (Initials) ka avatar banaye!
        this.user.picture = ''; 

      } catch (e) {
        console.error('Error parsing user data in header:', e);
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }
}